import { SET_FEATURE_GATE } from '../types/featureGateConstants'

/**
 * Set a feature gate value in Redux store
 * @param {string} flagName - Name of the feature gate (e.g., 'centrali3_0', 'canAccessMarketplace')
 * @param {boolean|string|number} value - Value of the feature gate
 */
export const setFeatureGate = (flagName, value) => {
  return {
    type: SET_FEATURE_GATE,
    payload: { flagName, value }
  }
}
